export const Tabs = {
  parts: ['tab', 'tablist', 'tabpanels', 'tabpanel', 'indicator'],
  variants: {
    custom: {
      tab: {
        fontWeight: 'bold',
        backgroundColor: 'transparent',
        borderBottom: '4px solid',
        borderColor: 'transparent',
        color: 'gray.600',
        marginBottom: '-4px!important',
        pt: 3,
        pb: 3,
        px: 3,
        height: 'auto',
        fontSize: '15px',
        lineHeight: '1.5',
        transition: 'all 0.2s ease-in-out',
        borderRadius: 0,
        _focus: { boxShadow: 'none' },
        _hover: { background: 'gray.100' },

        _selected: {
          borderColor: 'brand.orange.500',
          color: 'gray.800',
          outline: 'none',
          _hover: {
            background: 'transparent',
            cursor: 'default',
          },
        },
      },

      tablist: {
        borderBottom: '4px solid',
        borderColor: 'gray.100',
      },
    },
  },
};
